module.exports = __webpack_public_path__ + "../assets/mobile-1.jpg";